import axios from "axios";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import admin from "../layout/Admin";

export default async function adminTokenDev(mobileNo) {
    // const mobile = mobileNo || Cookies.getJSON("user")?.mobile;
    // const adminAccessToken = Cookies.get("admin_access_token");

    const mobile = mobileNo || JSON.parse(localStorage.getItem("user"))?.mobile;

    const adminAccessToken = localStorage.getItem("admin_access_token_dev");

    const {exp} = adminAccessToken ? jwtDecode(adminAccessToken) : {};

    console.log("Token Expired", exp > Math.floor(Date.now() / 1000));
    if (exp > Math.floor(Date.now() / 1000)) return adminAccessToken;

    console.log("Refreshing token");

    const {data} = await axios.post(
        "https://api-dev.clykk.com/um/clykk/ext/um/v1/sign-in",
        {
            "mobile":mobile,
            "countryCode": "91"
        }
    );

    // http://cgapp.clykk.com:9090
    // http://ec2-3-108-220-85.ap-south-1.compute.amazonaws.com:9090

    // Cookies.set("admin_access_token", data?.access_token);
    localStorage.setItem("admin_access_token_dev", data?.access_token);

    return data?.access_token;
}
